export const LIFECYCLE_ENVS = ['sandbox', 'dev', 'qa', 'stg', 'pre', 'prod'] as const;

export const REGION_VALUES = ['uk', 'us'] as const;

export const PROD_DOMAIN_PATTERNS = [
  { suffix: '.uk.irisifm.com', region: 'uk' as const },
  { suffix: '.us.irisifm.com', region: 'us' as const },
];

export const WORKFLOW_VALUES = ['upload', 'wopi_preview', 'search', 'retention'] as const;

export const STATUS_VALUES = ['started', 'success', 'failed'] as const;

export const GLOBAL_BLOCKLIST_KEYS = [
  'email',
  'username',
  'user_email',
  'user_name',
  'query',
  'search_query',
  'full_file_name',
] as const;

export const WORKFLOW_ALLOWLIST: Record<string, ReadonlyArray<string>> = {
  upload: ['doc_type', 'file_size_kb_bucket', 'duration_ms', 'http_status', 'error_code', 'retryable', 'operation'],
  wopi_preview: ['doc_type', 'load_ms', 'duration_ms', 'http_status', 'error_code', 'retryable', 'operation'],
  search: ['result_count', 'query_length_bucket', 'filters_applied', 'filter_count', 'duration_ms', 'http_status', 'error_code', 'retryable', 'operation'],
  retention: ['input_source', 'duration_ms', 'http_status', 'error_code', 'retryable', 'operation'],
};

export const JOURNEY_STEP_STATUS_VALUES = ['started', 'success', 'failed', 'abandoned'] as const;

export const JOURNEY_ABANDONMENT_REASON_VALUES = ['unknown', 'user_cancelled', 'timeout'] as const;

export const JOURNEY_RECOVERY_OUTCOME_VALUES = ['none', 'retry_failed', 'retry_success'] as const;

export const JOURNEY_REQUIRED_FIELDS = [
  'journey_id',
  'journey_name',
  'step_name',
  'step_order',
  'step_status',
  'duration_ms',
  'env',
] as const;

export const JOURNEY_OPTIONAL_FIELDS = [
  'region',
  'operation',
  'http_status',
  'error_code',
  'retryable',
  'abandonment_reason',
  'recovery_outcome',
  'time_to_first_upload_ms',
  'time_to_preview_open_ms',
  'time_to_search_results_ms',
  'app_version',
  'build_id',
  'feature_flag',
  'user_role',
  'tenant_type',
  'entry_point',
  'route',
  'lcp_ms',
  'inp_ms',
  'cls',
  'long_task_count',
  'slow_api_count',
  'slow_resource_count',
] as const;
